import { GetRequestOptions } from "./grunt";

const getKnjigePth=process.env.REACT_APP_GRUNT_API+"/knjiga";
const getKnjigeLokacijePth=process.env.REACT_APP_GRUNT_API+"/knjiga/lokacija";
const StatusOk={status:200};

const getKnjige=async()=>{
    
    try {
        const r = await fetch(getKnjigePth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getKnjigeShort=async()=>{
    
    try {
        const r = await fetch(getKnjigePth+"/short", GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getKnjigeLokacije=async()=>{
    
    try {
        const r = await fetch(getKnjigeLokacijePth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getKnjigaById=async(knjigaid)=>{
    
    try {
        const _pth=getKnjigePth+"/"+knjigaid;
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getKategorijeVrijednosti=async(namjenakey,knjigaid)=>{
    
    try {
        const _pth=getKnjigePth+"/kategorijevrijednosti/"+namjenakey+"/"+knjigaid;
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const addKnjiga=async(knjiga)=>{
    try {
        const _pth=getKnjigePth+"/";
        let _reqopt=GetRequestOptions("POST");
        _reqopt.body=JSON.stringify({ikg:knjiga.ikg,jibg:knjiga.jibg,naziv:knjiga.naziv,posjednik_id:knjiga.posjednik_id,vlasnik_id:knjiga.vlasnik_id,odjeljak_id:knjiga.odjeljak_id,povrsina:knjiga.povrsina,datupisregistar:knjiga.datupisregistar,mjesto:knjiga.mjesto,ulkbr:knjiga.ulkbr,pbr:knjiga.pbr,posta:knjiga.posta,opcina:knjiga.opcina,zupanija:knjiga.zupanija});
        const r = await fetch(_pth, _reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod spremanja knjige. " + ex.message, status: ex.status, name: ex.name};
    }
}

const updateKnjiga=async(knjiga)=>{
    try {
        const _pth=getKnjigePth+"/"+knjiga.id;
        let _reqopt=GetRequestOptions("PUT");
        _reqopt.body=JSON.stringify({ikg:knjiga.ikg,jibg:knjiga.jibg,naziv:knjiga.naziv,posjednik_id:knjiga.posjednik_id,vlasnik_id:knjiga.vlasnik_id,odjeljak_id:knjiga.odjeljak_id,povrsina:knjiga.povrsina,datupisregistar:knjiga.datupisregistar,mjesto:knjiga.mjesto,ulkbr:knjiga.ulkbr,pbr:knjiga.pbr,posta:knjiga.posta,opcina:knjiga.opcina,zupanija:knjiga.zupanija});
        const r = await fetch(_pth, _reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod spremanja knjige. " + ex.message, status: ex.status, name: ex.name};
    }
}

const updateKategorijeVrijednosti=async(knjigaid, rows)=>{
    try {
        const _pth=getKnjigePth+"/kategorijevrijednosti/"+knjigaid;
        let _reqopt=GetRequestOptions("PUT");
        _reqopt.body=JSON.stringify(rows);
        const r = await fetch(_pth, _reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod spremanja vrijednosti kategorija. " + ex.message, status: ex.status, name: ex.name};
    }
}
export {getKnjige,getKnjigaById, addKnjiga, updateKnjiga,getKnjigeLokacije, getKnjigeShort,getKategorijeVrijednosti,updateKategorijeVrijednosti};